export enum ResultType {
    All,
    Win,
    Loss
}
